import {
  IList,
  mapEach,
  mapNullable,
  WithPromiseState
} from 'annotation-tools/utils';
import { FetchListErrorReasonType } from './error-reason-type';
import {
  ListItemErrorValue,
  ListItemSuccessValue,
  ListItemUnresolvedValue,
  ListItemWithPromiseState
} from './list-item-with-status';
import {
  ListErrorValue,
  ListSuccessValue,
  ListUnresolvedValue,
  ListWithPromiseState
} from './list-with-status';

export const mapListLatest = <T, R>(
  listWithPromiseState: ListWithPromiseState<T>,
  mapFn: (list: IList<T>) => R
): WithPromiseState<
  { latest: R },
  { latest: R; reason: FetchListErrorReasonType },
  { latest: R }
> =>
  mapEach<
    ListUnresolvedValue<T>,
    ListErrorValue<T>,
    ListSuccessValue<T>,
    { latest: R },
    { latest: R; reason: FetchListErrorReasonType },
    { latest: R }
  >(
    u => ({ latest: mapFn(u.latest) }),
    e => ({ latest: mapFn(e.latest), reason: e.reason }),
    s => ({ latest: mapFn(s.latest) })
  )(listWithPromiseState);

export const mapListItemLatest = <T, R>(
  listItemWithPromiseState: ListItemWithPromiseState<T>,
  mapFn: (item: T) => R
): ListItemWithPromiseState<R> =>
  mapEach<
    ListItemUnresolvedValue<T>,
    ListItemErrorValue<T>,
    ListItemSuccessValue<T>,
    ListItemUnresolvedValue<R>,
    ListItemErrorValue<R>,
    ListItemSuccessValue<R>
  >(
    u => ({ latest: mapNullable(u.latest, mapFn) }),
    e => ({ latest: mapNullable(e.latest, mapFn), reason: e.reason }),
    s => ({ latest: mapFn(s.latest) })
  )(listItemWithPromiseState);
